import React from 'react';
import './Header.css'
import { Nav, Navbar } from 'react-bootstrap';

const Header = () => {
    return (
        <div className="container nav-bar">
            <Navbar collapseOnSelect expand="lg" variant="dark">
                <Navbar.Brand href="/">English Premier League</Navbar.Brand>
                <Navbar.Toggle aria-controls="responsive-navbar-nav" />
                <Navbar.Collapse id="responsive-navbar-nav">
                    <Nav>
                        <Nav.Link href="/home">Home</Nav.Link>
                        <Nav.Link eventKey={2} href="/about">About</Nav.Link>
                    </Nav>
                </Navbar.Collapse>
            </Navbar>
        </div>
    );
};

export default Header;